const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;

export function formatDateTime(value, locale = 'en-US') {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString(locale);
}

export function formatRelative(value, locale = 'en-US') {
  if (!value) return '';
  const then = (value instanceof Date ? value : new Date(value)).getTime();
  if (!Number.isFinite(then)) return '';
  const diffSeconds = Math.round((then - Date.now()) / 1000);
  const absSeconds = Math.abs(diffSeconds);

  let unit = 'second';
  let amount = diffSeconds;
  if (absSeconds >= YEAR) {
    unit = 'year';
    amount = Math.round(diffSeconds / YEAR);
  } else if (absSeconds >= MONTH) {
    unit = 'month';
    amount = Math.round(diffSeconds / MONTH);
  } else if (absSeconds >= DAY) {
    unit = 'day';
    amount = Math.round(diffSeconds / DAY);
  } else if (absSeconds >= HOUR) {
    unit = 'hour';
    amount = Math.round(diffSeconds / HOUR);
  } else if (absSeconds >= MINUTE) {
    unit = 'minute';
    amount = Math.round(diffSeconds / MINUTE);
  }

  try {
    const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
    return rtf.format(amount, unit);
  } catch (e) {
    return formatDateTime(then, locale);
  }
}
